import { Activo } from './activo';

export class Fichero {
    size: number;
    key: string;
    etag: string;
    lastmodified: any;
    storeclass: any;
    type: any;
    versions: Array<any>;
    versionElegida: any;
    name: string;
    activoAsociado: Activo;
    fa_icon: string;
 
    constructor(size, key, etag, lastmodified, storeclass, type, fa_icon?) {
        this.size = size;
        this.key = key;
        this.etag = etag;
        this.lastmodified = lastmodified;
        this.storeclass = storeclass;
        this.type = type;
        
        this.versions = new Array<any>();
        this.versionElegida = null;
        this.name = key;
        this.activoAsociado = null;

        // Icono Font-awesome
        this.fa_icon = fa_icon;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/modelos/fichero.ts